import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  const viewsInWan = (comic.views / 10000).toFixed(1);

  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 hover:-translate-y-1"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={comic.coverImage}
          alt={`${comic.title}漫画封面`}
          title={`${comic.title} - 57漫画网在线免费阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
            comic.status === '连载中'
              ? 'bg-accent-500 text-background-50'
              : 'bg-secondary-500 text-background-50'
          }`}>
            {comic.status}
          </span>
        </div>
        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-background-950/60 text-background-50 whitespace-nowrap backdrop-blur-sm">
            {comic.rating}分
          </span>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
        <div className="flex items-center gap-3 mt-2 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <div className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-eye-line"></i>
            </div>
            {viewsInWan}万
          </span>
          <span className="flex items-center gap-1">
            <div className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-heart-line"></i>
            </div>
            {(comic.favorites / 10000).toFixed(1)}万
          </span>
        </div>
      </div>
    </Link>
  );
}